import { InjectionToken } from '@angular/core';

export const PACKAGE_VISUALIZER_DATA = new InjectionToken<{}>('PACKAGE_VISUALIZER_DATA');
